import { render, staticRenderFns } from "./Staff_List.vue?vue&type=template&id=3a0cf130&scoped=true&"
import script from "./Staff_List.vue?vue&type=script&lang=js&"
export * from "./Staff_List.vue?vue&type=script&lang=js&"
import style0 from "./Staff_List.vue?vue&type=style&index=0&id=3a0cf130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0cf130",
  null
  
)

export default component.exports